import { render, staticRenderFns } from "./DateWiseStrengthPrint.vue?vue&type=template&id=35b1588a&scoped=true&"
import script from "./DateWiseStrengthPrint.vue?vue&type=script&lang=js&"
export * from "./DateWiseStrengthPrint.vue?vue&type=script&lang=js&"
import style0 from "./DateWiseStrengthPrint.vue?vue&type=style&index=0&id=35b1588a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1588a",
  null
  
)

export default component.exports